<template>
  <div class="pageHeader">
    <div class="nav-right">
      <el-dropdown trigger="click" @command="handleCommand">
       
        <span class="el-dropdown-link">{{userInfo.realname || userInfo.username}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown" class="header">
          <el-dropdown-item command="changePwd" v-if="appInfo && !userInfo.sso">{{$t('headBar.change_pwd')}}</el-dropdown-item>
          <el-dropdown-item command="logout">{{$t('headBar.logout')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" @command="changeEvent">
        <span class="el-dropdown-link">{{ $t('headBar.lang') }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown" class="header">
          <el-dropdown-item command="en">{{$t('headBar.en')}}</el-dropdown-item>
          <el-dropdown-item command="cn">{{$t('headBar.cn')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import './header.css'

export default {
  name: 'pageHeader',
  props: {
    defaultIndex: String,
    userInfo: {
      type: Object,
      required: true
    },
    appInfo: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    changeEvent: function(lang) {
      this.$emit('changeLang', lang)
    },
    handleCommand: function(command) {
      this[command]()
    },
    logout: function() {
      this.$emit('logout', 'logout')
    },
    changePwd: function() {
      this.$router.push({name: 'changePwd'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?2d7300c6